var initMiewFormacoes = function () {
    var circleAppender = $('.formacoes_grid').parents('.vc_row'),
        deltaY = $('body').innerWidth() < 960 ? 250 : 50,
        pathStart = "M 625.3 87 C 555.4 20.6 441.1 3.3 330 21.9 C 218.6 40.6 110.6 95.2 53.2 172.5 C -43 302.2 -2.1 549.7 123.2 651.3 C 239.7 745.6 464.3 727.2 572.2 623.1 C 636.9 560.8 682.7 457.7 696 354.7 C 709.3 251.7 690.4 148.9 625.3 87 Z",
        pathEnd = [
            "M 633.1 145.8 C 544.6 107.4 485 21.7 340 33.9 C 182.4 47.1 180 202.7 90 277.7 C -16.5 366.5 -28.1 512.4 107.2 600.2 C 168 639.6 288.4 644.6 432.1 601.8 C 558.1 564.3 844.6 601.8 867.1 379.8 C 877.5 276.4 802.6 219.3 633.1 145.8 Z",
            "M 708.4 194.2 C 640.9 94.7 513.4 -26.2 395 5.7 C 292.8 33.1 290.6 184.4 250 279.2 C 202.2 391.5 55.9 531.6 134.8 625.9 C 208.4 714.1 279.8 621.6 484.4 591.6 C 636.8 569.2 707 610.1 760.7 535.3 C 829 441.3 774.3 292 708.4 194.2 Z",
            "M 523.4 131.7 C 399.2 1.7 261.6 -7.4 168.7 7.2 C -20.5 37 0.7 328.7 0.7 328.7 C 0.7 328.7 13.2 435.3 142.7 503.5 C 260.8 565.7 321.7 595.5 603.4 728.4 C 682.3 765.6 872.1 673.2 794.3 528.6 C 665.4 289.3 614.2 226.7 523.4 131.7 Z",
        ];

    function animateCircle($el, nextSlide) {
        TweenLite.to($el.find('path'), 1.8, {
            scaleY: 1.1,
            y: deltaY,
            attr: { d: pathEnd[nextSlide] },
            ease: Elastic.easeOut
        });

        var picture = $('.formacoes_divs:eq(' + nextSlide + ')').find('picture')[0];
        var figcaption = $('.formacoes_divs:eq(' + nextSlide + ')').find('figcaption')[0];
        var smallInfo = $('.formacoes_divs:eq(' + nextSlide + ')').find('.small-info')[0];
        
        TweenLite.to([picture, figcaption], 1.5, {
            y: 0,
            autoAlpha: 1,
            delay:0.5,
            ease: Power2.easeout,
        });
        TweenLite.to(smallInfo, 1.5, {
            autoAlpha: 1,
            delay: 0.5,
            ease: Power2.easeout,
        });
    }

    $('.formacoes-slick').on('init', function () {
        circleAppender.append('<div class="formacoes_circle"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 716.2" xml:space="preserve"><g><path d="' + pathStart + '"></path></g></svg></div>');

        var $el = $('.formacoes_circle');
        animateCircle($el, 0);
    });
    $('.formacoes-slick').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        appendArrows: $('.formacoes_controls .arrows'),
        cursors: false,
        infinite: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 8000,
        fade: true,
        cssEase: 'ease',
        waitForAnimate: true
    });
    $('.formacoes-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $el = $('.formacoes_circle');
        var picture = $('.formacoes_divs:eq(' + currentSlide + ')').find('picture')[0];
        var figcaption = $('.formacoes_divs:eq(' + currentSlide + ')').find('figcaption')[0];
        var smallInfo = $('.formacoes_divs:eq(' + currentSlide + ')').find('.small-info')[0];
        
        TweenLite.to(smallInfo, 1.5, {
            autoAlpha: 0,
            delay: 0.5,
            ease: Power2.easeout,
        });
        TweenLite.to(picture, 1.5, {
            autoAlpha: 0,
            y: 80,
            delay: 0.5,
            ease: Power2.easeout,
        });
        TweenLite.to(figcaption, 1.5, {
            autoAlpha: 0,
            y: -80,
            delay: 0.5,
            ease: Power2.easeout,
        });

        animateCircle($el, nextSlide);
    });
}
